import i18n from '@/i18n'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
  try {
    // Translation
    if (i18n.locale === 'bn') {
      pdfMake.vfs = pdfFontsBn.pdfMake.vfs
    } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
    }

    // API Call
    const reportHeading = await ReportHeading.getReportHead(baseUrl, uri, orgId)

    // PDF
    const pdfContent = []

    //
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['25%', '50%', '25%'],
          body: [
            [
              { image: reportHeading.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
              { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
              { image: reportHeading.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
            ],
            [
              {},
              { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
              {}
            ],
            [
              {},
              {},
              {}
            ],
            [
              {},
              { text: reportHeading.address, style: 'address', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportTitle, style: 'address2', alignment: 'center' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      {
        table: {
          style: 'tableData',
          headerRows: 0,
          widths: ['50%', '50%'],
          body: [
            [
              { text: vm.$t('report_monthly.workplace_name') + ' : ' + (titleData.workplace_name ? titleData.workplace_name : ''), style: 'th', alignment: 'left' },
              {}
            ],
            [
              { text: vm.$t('social_service.fisyear') + ' : ' + vm.$n(titleData.fiscal_year_id - 1, { useGrouping: false }) + ' - ' + vm.$n(titleData.fiscal_year_id, { useGrouping: false }), style: 'th', alignment: 'left' },
              {}
            ],
            [
              { text: vm.$t('report.month_name') + ' : ' + vm.getMonthName(titleData.month_id), style: 'th', alignment: 'left' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // i
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.money_prv_moth'), colSpan: 6, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.cash_inc_re_month'), colSpan: 6, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.inc'), colSpan: 5, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.tot_report'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_depo'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.cash_hand'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.bank_dep'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.fdr'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_rest_money'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.goods_donar'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_rest_money'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.govt_donation'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.person_donation'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.jakat'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.mem_lif_sub'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.other_source'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_inc'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.medi_gls_whl'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.milk'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.clothing'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.inc_donr'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_inc'), style: 'th', alignment: 'center' },
              { },
              { }
            ],
            // 3
            [
              { text: vm.$n(1), style: 'th', alignment: 'center' },
              { text: vm.$n(2), style: 'th', alignment: 'center' },
              { text: vm.$n(3), style: 'th', alignment: 'center' },
              { text: vm.$n(4), style: 'th', alignment: 'center' },
              { text: vm.$n(5), style: 'th', alignment: 'center' },
              { text: vm.$n(6), style: 'th', alignment: 'center' },
              { text: vm.$n(7), style: 'th', alignment: 'center' },
              { text: vm.$n(8), style: 'th', alignment: 'center' },
              { text: vm.$n(9), style: 'th', alignment: 'center' },
              { text: vm.$n(10), style: 'th', alignment: 'center' },
              { text: vm.$n(11), style: 'th', alignment: 'center' },
              { text: vm.$n(12), style: 'th', alignment: 'center' },
              { text: vm.$n(13), style: 'th', alignment: 'center' },
              { text: vm.$n(14), style: 'th', alignment: 'center' },
              { text: vm.$n(15), style: 'th', alignment: 'center' },
              { text: vm.$n(16), style: 'th', alignment: 'center' },
              { text: vm.$n(17), style: 'th', alignment: 'center' },
              { text: vm.$n(18), style: 'th', alignment: 'center' },
              { text: vm.$n(19), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.cash_hand), style: 'th', alignment: 'center' },
              { text: vm.$n(data.bank_dep), style: 'th', alignment: 'center' },
              { text: vm.$n(data.fdr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.tot_rest_money), style: 'th', alignment: 'center' },
              { text: vm.$n(data.goods_donar), style: 'th', alignment: 'center' },
              { text: vm.$n(data.tot_rest_money2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.govt_donation), style: 'th', alignment: 'center' },
              { text: vm.$n(data.other_source), style: 'th', alignment: 'center' },
              { text: vm.$n(data.other_source), style: 'th', alignment: 'center' },
              { text: vm.$n(data.other_source), style: 'th', alignment: 'center' },
              { text: vm.$n(data.other_source), style: 'th', alignment: 'center' },
              { text: vm.$n(data.other_source + data.govt_donation), style: 'th', alignment: 'center' },
              { text: vm.$n(data.medi_gls_whl + data.medicine), style: 'th', alignment: 'center' },
              { text: vm.$n(data.milk), style: 'th', alignment: 'center' },
              { text: vm.$n(data.clothing), style: 'th', alignment: 'center' },
              { text: vm.$n(data.inc_donr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.medicine + data.medi_gls_whl + data.milk + data.clothing + data.inc_donr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.medicine + data.medi_gls_whl + data.milk + data.clothing + data.inc_donr + data.other_source + data.govt_donation), style: 'th', alignment: 'center' },
              { text: vm.$n(data.tot_rest_money2 + data.medicine + data.medi_gls_whl + data.milk + data.clothing + data.inc_donr + data.other_source + data.govt_donation), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // ii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.withdraw_from_bank'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.money_prv_moth'), colSpan: 9, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.inc_spend'), colSpan: 5, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.tot_cost_repot_month'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              {},
              { text: vm.$t('report.medicine'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.types_of_test'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.blood_clothing'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.wheel_chair'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.milk_diet'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.fare_cost'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.dialysis'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.miscellaneous'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_cash_out') + '\n (' + vm.$n('21') + ' ' + vm.$t('globalTrans.to') + ' ' + vm.$n('28') + ') \n' + vm.$t('report.sum'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.medi_gls_whl'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.milk_diet'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.clothing'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.inc_donr_buy'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_cash'), style: 'th', alignment: 'center' },
              {}
            ],
            // 3
            [
              { text: vm.$n(20), style: 'th', alignment: 'center' },
              { text: vm.$n(21), style: 'th', alignment: 'center' },
              { text: vm.$n(22), style: 'th', alignment: 'center' },
              { text: vm.$n(23), style: 'th', alignment: 'center' },
              { text: vm.$n(24), style: 'th', alignment: 'center' },
              { text: vm.$n(25), style: 'th', alignment: 'center' },
              { text: vm.$n(26), style: 'th', alignment: 'center' },
              { text: vm.$n(27), style: 'th', alignment: 'center' },
              { text: vm.$n(28), style: 'th', alignment: 'center' },
              { text: vm.$n(29), style: 'th', alignment: 'center' },
              { text: vm.$n(30), style: 'th', alignment: 'center' },
              { text: vm.$n(31), style: 'th', alignment: 'center' },
              { text: vm.$n(32), style: 'th', alignment: 'center' },
              { text: vm.$n(33), style: 'th', alignment: 'center' },
              { text: vm.$n(34), style: 'th', alignment: 'center' },
              { text: vm.$n(35), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.withdraw_from_bank), style: 'th', alignment: 'center' },
              { text: vm.$n(data.medicine2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.types_of_test), style: 'th', alignment: 'center' },
              { text: vm.$n(data.clothing2) + '/' + vm.$n(data.blood), style: 'th', alignment: 'center' },
              { text: vm.$n(data.wheel_chair), style: 'th', alignment: 'center' },
              { text: vm.$n(data.milk_diet), style: 'th', alignment: 'center' },
              { text: vm.$n(data.fare_cost), style: 'th', alignment: 'center' },
              { text: vm.$n(data.dialysis), style: 'th', alignment: 'center' },
              { text: vm.$n(data.miscellaneous), style: 'th', alignment: 'center' },
              { text: vm.$n(data.medicine2 + data.types_of_test + data.blood + data.clothing2 + data.wheel_chair + data.milk_diet + data.miscellaneous + data.dialysis + data.miscellaneous), style: 'th', alignment: 'center' },
              { text: vm.$n(data.wheel_chair3), style: 'th', alignment: 'center' },
              { text: vm.$n(data.milk_diet3), style: 'th', alignment: 'center' },
              { text: vm.$n(data.clothing3) + '/' + vm.$n(data.blood3), style: 'th', alignment: 'center' },
              { text: vm.$n(data.inc_donr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.wheel_chair3 + data.milk_diet3 + data.blood3 + data.inc_donr_buy + data.clothing3), style: 'th', alignment: 'center' },
              { text: vm.$n(data.withdraw_from_bank + data.medicine2 + data.types_of_test + data.blood + data.clothing2 + data.wheel_chair + data.milk_diet + data.miscellaneous + data.dialysis + data.miscellaneous + data.wheel_chair3 + data.milk_diet3 + data.blood3 + data.inc_donr_buy + data.clothing3), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    // Page Break
    pdfContent.push(
      { text: '', style: 'empty_space', pageBreak: 'before' }
    )

    // iii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: '*',
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.report_mouth_fund'), colSpan: 5, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              { text: vm.$t('report_monthly.tot_inc_report') + '\n (' + vm.$n('39') + ' + ' + vm.$n('40') + ') \n' + vm.$t('report.sum'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.first_july') + vm.$n(titleData.fiscal_year_id - 1) + vm.$t('report_monthly.frm_fis_tot_inc'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.first_july') + vm.$n(titleData.fiscal_year_id - 1) + vm.$t('report_monthly.frm_fis_tot_spend'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.cash_hand'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.bank_dep'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.fdr'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_rest_money') + '\n (' + vm.$n('36') + ' ' + vm.$t('globalTrans.to') + ' ' + vm.$n('38') + ') \n' + vm.$t('report.sum'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.grant_from_goods'), style: 'th', alignment: 'center' },
              {},
              {},
              {}
            ],
            // 3
            [
              { text: vm.$n(36), style: 'th', alignment: 'center' },
              { text: vm.$n(37), style: 'th', alignment: 'center' },
              { text: vm.$n(38), style: 'th', alignment: 'center' },
              { text: vm.$n(39), style: 'th', alignment: 'center' },
              { text: vm.$n(40), style: 'th', alignment: 'center' },
              { text: vm.$n(41), style: 'th', alignment: 'center' },
              { text: vm.$n(42), style: 'th', alignment: 'center' },
              { text: vm.$n(43), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.cash_hand2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.bank_dep2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.fdr2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.cash_hand2 + data.bank_dep2 + data.fdr2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.goods_donar2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.cash_hand2 + data.bank_dep2 + data.fdr2 + data.goods_donar2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.frm_fis_tot_inc), style: 'th', alignment: 'center' },
              { text: vm.$n(data.frm_fis_tot_spend), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    // iii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: '*',
          body: [
            // 1
            [
              { text: vm.$t('report_monthly.grants_rcv_swc'), colSpan: 2, style: 'th', alignment: 'center' },
              {},
              { text: vm.$t('report_monthly.gnr_assoi'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('social_service.comment'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.tot_cost_repot_month_NEW'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_cost'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.moeny_start'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_semi'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.tot_semi_year'), style: 'th', alignment: 'center' },
              {}
            ],
            // 3
            [
              { text: vm.$n(44), style: 'th', alignment: 'center' },
              { text: vm.$n(45), style: 'th', alignment: 'center' },
              { text: vm.$n(46), style: 'th', alignment: 'center' },
              { text: vm.$n(47), style: 'th', alignment: 'center' },
              { text: vm.$n(48), style: 'th', alignment: 'center' },
              { text: vm.$n(49), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.tot_cost_repot_month_NEW), style: 'th', alignment: 'center' },
              { text: vm.$n(data.tot_cost), style: 'th', alignment: 'center' },
              { text: vm.$n(data.moeny_start), style: 'th', alignment: 'center' },
              {},
              {},
              {}
            ]
          ]
        }
      }
    )
    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 8,
            margin: [2, 2, 2, 2],
            bold: true
          },
          td: {
            fontSize: 7,
            margin: [2, 2, 2, 2]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
      }
    }

    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
      //
    }
  }
}

export default {
  exportPdfDetails
}
